"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function cdn(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M12.0004 4.5L10.7554 6.762C10.6144 7.008 10.3616 6.9855 10.1081 6.84825L9.20813 6.393L9.87863 9.86775C10.0204 10.503 9.56738 10.503 9.34388 10.2277L7.77038 8.5125L7.51538 9.384C7.48538 9.49875 7.35638 9.61875 7.16213 9.59025L5.17463 9.18225L5.69588 11.0333C5.80838 11.445 5.89538 11.6152 5.58338 11.7232L4.87463 12.0488L8.29688 14.7577C8.3649 14.8094 8.41604 14.8801 8.44382 14.9609C8.47159 15.0417 8.47475 15.1289 8.45288 15.2115L8.15288 16.17C9.33188 16.0372 10.3879 15.8385 11.5669 15.7155C11.6711 15.705 11.8451 15.8722 11.8444 15.99L11.6891 19.5H12.2621L12.1721 15.9975C12.1714 15.8798 12.3296 15.705 12.4331 15.7155C13.6121 15.8385 14.6681 16.038 15.8464 16.17L15.5471 15.2115C15.5252 15.1289 15.5283 15.0417 15.5561 14.9609C15.5838 14.8801 15.635 14.8094 15.7031 14.7577L19.1254 12.0488L18.4166 11.724C18.1046 11.6153 18.1916 11.445 18.3041 11.0333L18.8261 9.18225L16.8379 9.59025C16.6436 9.61875 16.5139 9.49875 16.4854 9.384L16.2296 8.5125L14.6569 10.2285C14.4334 10.503 13.9804 10.503 14.1221 9.8685L14.7934 6.393L13.8926 6.84825C13.6391 6.9855 13.3864 7.008 13.2454 6.762L12.0004 4.5Z", fill: color }));
}
exports["default"] = cdn;
//# sourceMappingURL=cdn.js.map